"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var react_bootstrap_1 = require("react-bootstrap");

var react_router_dom_1 = require("react-router-dom");

var index_1 = require("../../index");

require("./ObjectIngestPopover.css");

var ObjectIngestPopoverContent = function (_a) {
  var target = _a.target,
      show = _a.show,
      _b = _a.onCancel,
      onCancel = _b === void 0 ? function () {} : _b,
      _c = _a.onInsertText,
      onInsertText = _c === void 0 ? function () {} : _c,
      _d = _a.onInsertPowerBi,
      onInsertPowerBi = _d === void 0 ? function () {} : _d,
      _e = _a.onInsertExcelOrPPT,
      onInsertExcelOrPPT = _e === void 0 ? function () {} : _e,
      allowTextOnly = _a.allowTextOnly,
      isPowerBiEnabled = _a.isPowerBiEnabled;
  var ref = (0, react_1.useRef)();
  var url = (0, react_router_dom_1.useRouteMatch)().url;

  var handleAddLibraryItem = function (e) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        e.preventDefault();
        onCancel();

        if (onInsertExcelOrPPT) {
          onInsertExcelOrPPT();
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  var handlePowerBi = function (e) {
    e.preventDefault();
    onCancel();

    if (onInsertPowerBi) {
      onInsertPowerBi();
    }
  };

  var handleText = function (e) {
    e.preventDefault();

    if (onInsertText) {
      onInsertText();
    }
  };

  var textOnlyIconClassName = "outline icon-grey-medium";
  return (0, jsx_runtime_1.jsx)("div", __assign({
    ref: ref,
    "data-testid": "ingest-select-popover"
  }, {
    children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Overlay, __assign({
      show: show,
      target: target,
      rootClose: true,
      onHide: onCancel,
      container: ref.current,
      placement: "bottom"
    }, {
      children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Popover, __assign({
        className: "ingest-select-popover"
      }, {
        children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Popover.Content, __assign({
          className: "popup-menu popup-confirmation ingest-select-popover"
        }, {
          children: [allowTextOnly ? // eslint-disable-next-line react/button-has-type
          (0, jsx_runtime_1.jsxs)("button", __assign({
            className: "ui-button button-no-underline allowTextOnly",
            disabled: true
          }, {
            children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
              name: "powerpoint",
              width: 24,
              height: 24,
              className: textOnlyIconClassName
            }, void 0), (0, jsx_runtime_1.jsx)("span", {
              children: "Excel or PowerPoint"
            }, void 0)]
          }), void 0) : (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, __assign({
            className: "ui-button button-no-underline",
            to: url + "/library-items",
            onClick: handleAddLibraryItem
          }, {
            children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
              name: "powerpoint",
              width: 24,
              height: 24,
              className: "outline icon-orange-theme"
            }, void 0), (0, jsx_runtime_1.jsx)("span", {
              children: "Excel or PowerPoint"
            }, void 0)]
          }), void 0), isPowerBiEnabled && (allowTextOnly ? // eslint-disable-next-line react/button-has-type
          (0, jsx_runtime_1.jsxs)("button", __assign({
            className: "ui-button button-no-underline allowTextOnly",
            disabled: true
          }, {
            children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
              name: "powerbi-new",
              width: 24,
              height: 24,
              className: textOnlyIconClassName
            }, void 0), (0, jsx_runtime_1.jsx)("span", {
              children: "Power BI"
            }, void 0)]
          }), void 0) : (0, jsx_runtime_1.jsxs)(index_1.Button, __assign({
            className: "button-no-underline",
            onClick: handlePowerBi
          }, {
            children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
              name: "powerbi-new",
              width: 24,
              height: 24,
              className: "outline icon-orange-theme"
            }, void 0), (0, jsx_runtime_1.jsx)("span", {
              children: "Power BI"
            }, void 0)]
          }), void 0)), (0, jsx_runtime_1.jsxs)(index_1.Button, __assign({
            className: "button-no-underline",
            onClick: handleText
          }, {
            children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
              name: "textbox",
              width: 24,
              height: 24,
              className: "outline icon-orange-theme"
            }, void 0), (0, jsx_runtime_1.jsx)("span", {
              children: "Text"
            }, void 0)]
          }), void 0)]
        }), void 0)
      }), void 0)
    }), void 0)
  }), void 0);
};

var ObjectIngestPopover = function (_a) {
  var _b = _a.onInsertText,
      onInsertText = _b === void 0 ? function () {} : _b,
      _c = _a.onPopover,
      onPopover = _c === void 0 ? function () {} : _c,
      _d = _a.onInsertExcelOrPPT,
      onInsertExcelOrPPT = _d === void 0 ? function () {} : _d,
      _e = _a.onInsertPowerBi,
      onInsertPowerBi = _e === void 0 ? function () {} : _e,
      allowTextOnly = _a.allowTextOnly,
      isPowerBiEnabled = _a.isPowerBiEnabled;
  var target = (0, react_1.useRef)();

  var _f = (0, react_1.useState)(false),
      isOpen = _f[0],
      setIsOpen = _f[1];

  var showPopover = function (e) {
    e.preventDefault();
    setIsOpen(true);
    onPopover(true);
  };

  var hidePopover = function () {
    setIsOpen(false);
    onPopover(false);
  };

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      ref: target
    }, {
      children: (0, jsx_runtime_1.jsx)(index_1.Button, __assign({
        className: "ui-button button-link object-ingest-toggle",
        onClick: showPopover
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "plus",
          width: 24,
          className: "outline icon-orange"
        }, void 0)
      }), void 0)
    }), void 0), (0, jsx_runtime_1.jsx)(ObjectIngestPopoverContent, {
      target: target,
      show: isOpen,
      onCancel: hidePopover,
      onInsertText: onInsertText,
      onInsertPowerBi: onInsertPowerBi,
      onInsertExcelOrPPT: onInsertExcelOrPPT,
      allowTextOnly: allowTextOnly,
      isPowerBiEnabled: isPowerBiEnabled
    }, void 0), (0, jsx_runtime_1.jsx)("p", __assign({
      className: "object-ingest-label"
    }, {
      children: "Add an item"
    }), void 0)]
  }, void 0);
};

exports.default = ObjectIngestPopover;